import { createFetchTypes } from '../../utils/createFetchTypes';

export const REPLACE_EDITED_PATIENT = 'REPLACE_EDITED_PATIENT';
export const ADD_APPOINTMENT = 'ADD_APPOINTMENT';
export const CHANGE_APPOINTMENT_SIGNAL = 'CHANGE_APPOINTMENT_SIGNAL';
export const DELETE_APPOINTMENT_SIGNAL = 'DELETE_APPOINTMENT_SIGNAL';
export const TOGGLE_FORCE_RELOAD = 'TOGGLE_FORCE_RELOAD';
export const SET_HOUR = 'SET_HOUR';
export const SET_DATE = 'SET_DATE';
export const SET_WEEK = 'SET_WEEK';
export const SET_SELECTED_APPOINTMENT = 'SET_SELECTED_APPOINTMENT';
export const SET_EDITED_APPOINTMENT = 'SET_EDITED_APPOINTMENT';
export const ADD_PATIENT_APPOINTMENT = 'ADD_PATIENT_APPOINTMENT';
export const REMOVE_PATIENT_APPOINTMENT = 'REMOVE_PATIENT_APPOINTMENT';
export const EDIT_PATIENT_APPOINTMENT = 'EDIT_PATIENT_APPOINTMENT';
export const CHANGE_APPOINTMENT_STATUS = 'CHANGE_APPOINTMENT_STATUS';

// ************ createFetchType

export const GET_APPOINTMENTS = createFetchTypes('GET_APPOINTMENTS');
export const GET_PATIENT_APPOINTMENTS = createFetchTypes('GET_PATIENT_APPOINTMENTS');
export const SET_SELECTED_ADMISSION = createFetchTypes('SET_SELECTED_ADMISSION');
